import i18n from 'i18next';

const INBOX_PT_BR = {
  sidebar: {
    inbox: 'Caixa de Entrada',
  },
  inbox: {
    title: 'Caixa de Entrada',
    noConversation: 'Selecione uma conversa para começar',
    messageSent: 'Mensagem enfileirada para envio',
    filterAll: 'Todos',
    filterUnread: 'Não lidas',
    filterMine: 'Minhas',
    comingSoon: 'Em breve',
  },
} as const;

const INBOX_EN_US = {
  sidebar: {
    inbox: 'Inbox',
  },
  inbox: {
    title: 'Inbox',
    noConversation: 'Select a conversation to start',
    messageSent: 'Message queued for delivery',
    filterAll: 'All',
    filterUnread: 'Unread',
    filterMine: 'Mine',
    comingSoon: 'Coming soon',
  },
} as const;

let registered = false;

export function registerInboxTranslations(): void {
  if (registered) return;
  i18n.addResourceBundle('pt-BR', 'translation', INBOX_PT_BR, true, true);
  i18n.addResourceBundle('en-US', 'translation', INBOX_EN_US, true, true);
  registered = true;
}
